export default __webpack_public_path__ + "static/media/Email_Illustration_desktop.85119e09.png";